import { BaseType } from "../../../domain/base/base-type";

const TabUiStateLiteralList = [
  "BASIC",
  "FORM",
  "TENANT_PROCESS_RESULT",
  "ISSUE_FILE",
  "PAYMENT",
  "TIMELINE",
  // "MESSAGES"
] as const;

type TabUiStateLiterals = (typeof TabUiStateLiteralList)[number];

/**
 * 画面の表示状態を表す
 */
export class TabUiState extends BaseType<TabUiStateLiterals> {
  static isValid(tab?: string): tab is TabUiStateLiterals {
    return TabUiStateLiteralList.indexOf(tab as TabUiStateLiterals) !== -1;
  }

  static initialize() {
    return new TabUiState("BASIC");
  }
  static form() {
    return new TabUiState("FORM");
  }
  static tenantProcessResult() {
    return new TabUiState("TENANT_PROCESS_RESULT");
  }
  static issueFile() {
    return new TabUiState("ISSUE_FILE");
  }
  static payment() {
    return new TabUiState("PAYMENT");
  }
  static timeline() {
    return new TabUiState("TIMELINE");
  }
  static messages() {
    throw new Error(`Not supported yet`);
  }
}
